import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'upmarket-my_teams_link_account_settings-click';

/**
 * Event to track the "My team" link in the account settings dropdown, as well as the account settings menus. Only parameter is the type of user who clicked it (OWNER, ADMIN, or CONTRIBUTOR).
 */
export function trackUpmarketMyTeamsLinkAccountSettingsClick(
  account_type_of_clicker_OWNER_ADMIN_or_CONTRIBUTOR_Custom: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { account_type_of_clicker_OWNER_ADMIN_or_CONTRIBUTOR_Custom },
  });
}
